import { createSelector } from '@ngrx/store';
import { getOrderBuilderState } from '../../../reducers';

/**
 * Exports retail specification state
 */
export const getRetailSpecificationPage = createSelector(
  getOrderBuilderState,
  state => {
    return state.retailSpecificationPage;
  },
);
